module.exports = {"id":1,"objectData":[{"title":"Кадастровый номер ИМ","value":"36:28:8100013:292"},{"title":"Кадастровый квартал","value":"36:234:23652"},{"title":"Кадастровый номер ЗУ, из которого образован","value":""},{"title":"Площадь по документам","value":"1324"},{"title":"Кадастровый номер ИМ","value":"36:28:8100013:292"},{"title":"Кадастровый квартал","value":"36:234:23652"},{"title":"Кадастровый номер ЗУ, из которого образован","value":""},{"title":"Площадь по документам","value":"1324"}]}


//////////////////
// WEBPACK FOOTER
// ./src/mixins/data/objectFull2.json
// module id = fAfa
// module chunks = 1